import { isMobile } from '@elfsight/widget-utils';

export const devices = ({ displayDevices }) => {
  if (isMobile() && displayDevices.includes('mobile')) {
    return true;
  }

  return !isMobile() && displayDevices.includes('desktop');
};
